export const HIGHLIGHTED_PHRASES_ENDPOINT_KEY = 'highlighted-phrases'
